<template>
  <div class="products">
    <Banner :banner="banner" />
    <div class="container w1320">
      <div class="title">
        <div class="cn">产品中心</div>
        <div class="en">Product Center</div>
      </div>
      <div class="list">
        <div class="item" v-for="item in type" :key="item.ID">
          <a @click="goto(item.ID)">
            <img :src="`http://boyang.sansg.com/upload/${item.PICURL}`" alt="" class="img wow">
            <div class="product-listed__hover">
              <div class="cover"></div>
              <div class="meta">
                <div class="title">{{item.CALLED}}</div>
                <div class="more">- 查看更多 -</div>
              </div>
            </div>
          </a>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import {WOW} from 'wowjs'
import Scrollbar from 'smooth-scrollbar';
export default {
  components: {
    Banner
  },
  data(){
    return{
      banner:{
        title:'产品中心',
        img:'/images/productsTypebanner.jpg'
      },
      type:[]
    }
  },
  created(){
    this.getProductType()
  },
  mounted(){

  },
  methods: {
    getProductType(tid){
      this.$$axios.get('/php/productstype.php', {
        params: {
          tid: 63,
          num:10
        }
      })
      .then(res=>{
        this.type=res.data
      }).then(()=>{
        let wow=new WOW({offset:200})
        this.$nextTick(()=>{
          wow.init()
          window.pageYOffset=0
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.addListener((status) => {
            window.pageYOffset=status.offset.y
            wow.scrollHandler()
          });
        })
      })
      .catch(error=>{
        console.log(error);
      });
    },
    goto(tid){
      this.$router.push({
        name:'products',
        params:{
          tid
        }
      })
    }
  }
}
</script>

<style scoped>
.products{
  overflow: hidden;
}
.products .container>.title{
  text-align: center;
  padding: 45px 0;
}
.products .container>.title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.products .container>.title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.products .list{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -11px;
}
.products .list .item{
  width: 50%;
  padding: 0 11px;
  margin-bottom: 24px;
}
.products .list .item a{
  display: block;
  position: relative;
  cursor: pointer;
}
.products .list .item img.img{
  display: block;
  width: 100%;
	animation-name: polygon;
	animation-duration: 2s;
}
@keyframes polygon {
  0% {
    clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%);
  }
  100% {
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
  }
}
.products .list .item .product-listed__hover{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(94,121,135,.8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: 1s;
}
.products .list .item:hover .product-listed__hover{
  visibility: visible;
  opacity: 1;
}
.products .list .item .product-listed__hover .meta{
  transform: translateY(20px);
  transition: 1s;
  text-align: center;
}
.products .list .item:hover .product-listed__hover .meta{
  transform: translateY(0);
}
.products .list .item .product-listed__hover .meta .title{
  font-size: 18px;
}
.products .list .item .product-listed__hover .meta .more{
  font-size: 12px;
  font-weight: lighter;
  margin-top: 5px;
}
@media(max-width: 768px){
  .products .list .item{
    width: 100%;
  }
}
</style>


